import { RootState } from '@core/store/rootReducer';
import { PREFERENCES_ENTITY_ID, defaultPreferencesState, preferencesReducer } from './PreferencesReducer';
import { createSelector } from '@reduxjs/toolkit';

const preferencesState = (state: RootState) => state.preferences;

export const preferencesSelector = createSelector([preferencesState], (state) => {
  return {
    ...state,
    preferences:
      preferencesReducer.entityAdapter.getSelectors().selectById(state, PREFERENCES_ENTITY_ID) ??
      defaultPreferencesState,
    loading: state.loadingPending > 0,
  };
});
